import { Component, ViewChild, EventEmitter, ElementRef, OnChanges, Input, Output } from '@angular/core';
import {  BehaviorSubject, fromEvent, Observable, Subject, Subscription, } from 'rxjs';
import moment_ from 'moment';

import { MiniTracker, DateUtil, MiniTrackerUtil } from 'huddyapi';

const moment = moment_;

@Component({
    selector: 'symptom-widget',
    templateUrl: 'symptom-widget.html',
    styleUrls: ['./symptom-widget.scss'],
    inputs: ['data', 'caller', 'word1', 'word2', 'word3', 'clearSubject$', 'forForecast', 'yesterdayLoaded', 'yesterdayValue']
}) 
export class SymptomWidget implements OnChanges {
    @Input() data: MiniTracker;
    @Input() clearSubject$ : Subject<boolean>;
    clearSub : Subscription;
    disabled: number;
    @Input() caller;
    @Input()forForecast? : boolean = false;
    @Input() yesterdayLoaded : boolean = false;
    @Input() yesterdayValue : {"yesterdayValue": number, "todayValue": number};
    yesterdayPos : number;
    notableChange: boolean = false;

    
    @ViewChild('canvasParent', { static: true }) canvasParent: ElementRef;
    @ViewChild('loggingCanvas', { static: true }) canvas: ElementRef;
    @ViewChild('word1Label', { static: true }) word1Label: ElementRef;
    @ViewChild('word2Label', { static: true }) word2Label: ElementRef;
    @ViewChild('word3Label', { static: true }) word3Label: ElementRef;


    width: number;
    segmentPositions: number[];
    @Input()word1: string = '';
    @Input()word2: string = '';
    @Input()word3: string = '';
    @Output()callActionSheet: EventEmitter<MiniTracker> = new EventEmitter();

    lineMargin: number;
    observableInitialized: boolean = false;
    slider: Slider;
    canvasWidth : number;
    static symptomPoor: string = "#f8abce";
    static symptomMediocre: string = "#dac7fd";
    static symptomFair: string = "#e9d9ff";
    static symptomAverage: string = "#c7e3ff";
    static symptomGood: string = "#a1caff";
    static LINE_OFFSET: number = 20;
    static X_OFFSET: number = 1;
    static TEXT_OFFSET: number = 15;
    static FONT: string = '11pt Open Sans';
    static HEIGHT: number = 55;
    static MARGIN: number = .05;
    static INSET: number = 20;
    static NODE_RADIUS: number = 5;
    static HIT_RADIUS: number = 17; 
    static POSITION_COLORS = [SymptomWidget.symptomPoor, SymptomWidget.symptomMediocre, SymptomWidget.symptomFair, SymptomWidget.symptomAverage, SymptomWidget.symptomGood];
    static POSITION_BORDER_COLORS = [SymptomWidget.symptomPoor, SymptomWidget.symptomMediocre, SymptomWidget.symptomFair, SymptomWidget.symptomAverage, SymptomWidget.symptomGood];
    static NUM_NODES : number = 5;
    static YESTERDAY_CARAT : number = 8;

    constructor() {
       
    }

    setSelected(selected: number, ctx?) {
        if(!ctx)
            ctx = this.canvas.nativeElement.getContext("2d");
        this.slider.position = selected;
        this.setMeasurement();
        this.slider.moveTo(ctx, this.segmentPositions)
        this.slider.setSelected(false);

    }

    captureMouseEvents(canvasEl: HTMLCanvasElement) {
        if(!this.observableInitialized) {
            var ctx = canvasEl.getContext("2d");

            canvasEl.addEventListener('contextmenu', function(e) {
                e.preventDefault();
            });
            fromEvent(canvasEl, 'touchstart')
                .subscribe((res: TouchEvent) => {
                    var touch = this.resolveTouch(res);
                    if (touch)
                     this.handleTouchStart(canvasEl, ctx, touch.clientX, touch.clientY);
                });
            fromEvent(canvasEl, 'touchmove')
                .subscribe((res: TouchEvent) => {
                     res.preventDefault();
                     var touch = this.resolveTouch(res);
                     if (touch)
                      this.handleTouchMove(canvasEl, ctx, touch.clientX)
                });
            fromEvent(canvasEl, 'touchend')
                .subscribe((res: TouchEvent) => {
                    res.preventDefault();
                    var touch = this.resolveTouch(res);
                    if (touch)
                      this.handleTouchEnd(canvasEl, ctx, touch.clientX)
                });
            fromEvent(canvasEl, 'mousedown')
                .subscribe((res: MouseEvent) => {
                    this.handleTouchStart(canvasEl, ctx, res.clientX, res.clientY);
                });
            fromEvent(canvasEl, 'mousemove')
                .subscribe((res: MouseEvent) => {
                     res.preventDefault();
                     this.handleTouchMove(canvasEl, ctx, res.clientX)
                });
            fromEvent(canvasEl, 'mouseup')
                .subscribe((res: MouseEvent) => {
                    res.preventDefault();
                    this.handleTouchEnd(canvasEl, ctx, res.clientX)
                });
            this.observableInitialized = true;
        //    MobileLog.logClassLevel(0, 'SymptomWidget','exiting ccaptureMouseEvents')
        }


    }

    resolveTouch(res : TouchEvent) : Touch {
      let arr : TouchList = res.touches;
      if (arr.length === 0) {
        arr = res.changedTouches;
      }
      if (arr.length > 0) {
        return arr[0];
      }
      return undefined;
    }

    handleTouchStart(canvasEl: HTMLCanvasElement, ctx, clientX : number, clientY: number) {
          var rect = canvasEl.getBoundingClientRect();
          var x: number = clientX - rect.left;
          var y: number = clientY - rect.top;

          if((this.slider) && (this.slider.contains(x, y))) {
              this.slider.setSelected(true);
          } else {
              var selected = this.segmentNodeSelected(x, y);//did we click on a node?
              if(selected > -1) {
                  this.setSelected(selected, ctx);
              }
          }
    }

 
    getYesterdayValue() : string {
      return this.data.yesterdayValue ? MiniTrackerUtil.getSymptomValue(+this.data.yesterdayValue).toLowerCase() : undefined;
    }

    handleTouchMove(canvasEl: HTMLCanvasElement, ctx, clientX : number) {
      if((this.slider) && (this.slider.isSelected())) {
        var rect = canvasEl.getBoundingClientRect();
        var x: number = clientX - rect.left;
        if((x >= this.lineMargin) && (x <= (this.width - this.lineMargin)))
            this.redraw(x, ctx);
      }
    }

    handleTouchEnd(canvasEl: HTMLCanvasElement, ctx, clientX : number) {
      if((this.slider)) {
        var rect = canvasEl.getBoundingClientRect();
        var x: number = clientX - rect.left;
        this.slider.x = x;
        this.slider.moveToNearest(ctx, this.segmentPositions)
        this.setMeasurement();
        this.drawYesterdayValue(ctx);    
        this.slider.setSelected(false);
    }
    }

    getJson() {
        return JSON.stringify(this.data);
    }

    setMeasurement() {
        if(this.slider) {
            this.data.dirty = true;
            this.data.currentVal = this.sliderValueToMeasurementValue();
            if (this.forForecast)
                this.caller.setTrackable(this.data);
           
        }
    }

    sliderValueToMeasurementValue() : number {
      return 100 - (this.slider.position * 100 / (SymptomWidget.NUM_NODES - 1));
    }

    getSelectedWord(): string {
        var ret: string = '';
        if(this.slider) {
            switch(this.slider.position) {
                case 0: {
                    ret = this.word1; break;
                }
                case 2: {
                    ret = this.word2; break;
                }
                case 4: {
                    ret = this.word3; break;
                }
            }
        }
        return ret;
    }

    isSelected(index: number): boolean {
        var ret = false;
        if(this.slider)
            ret = (index == this.slider.position);
        return ret;
    }

    redraw(x: number, ctx) {
        ctx.clearRect(0, 0, this.canvas.nativeElement.width, this.canvas.nativeElement.height);
        this.drawBackground(ctx);
        this.slider.draw(x, SymptomWidget.LINE_OFFSET, ctx);
        this.drawYesterdayValue(ctx);
    }

    segmentNodeSelected(x: number, y: number): number {
        var ret = -1;
        var yMin = SymptomWidget.LINE_OFFSET - SymptomWidget.HIT_RADIUS;
        var yMax = SymptomWidget.LINE_OFFSET + SymptomWidget.HIT_RADIUS;
        if(y >= yMin && y <= yMax) {
            for(let n = 0; n < this.segmentPositions.length; n++) {
                var xMin = this.segmentPositions[n] - SymptomWidget.HIT_RADIUS;
                var xMax = this.segmentPositions[n] + SymptomWidget.HIT_RADIUS;
                if(x >= xMin && x <= xMax) {
                    ret = n;
                    break;
                }
            }
        }
        return ret;
    }

    ngOnChanges(changes) {
        this.reinitialize();
        if ((this.clearSubject$ && !this.clearSub) || changes["yesterdayValue"]) {
            if (this.yesterdayValue){
                this.yesterdayPos = Math.floor((100 - this.yesterdayValue.yesterdayValue) * (SymptomWidget.NUM_NODES - 1) / 100);
            }

            this.clearSub = this.clearSubject$.subscribe(b => {
                // MobileLog.logClassLevel(0, 'SymptomWidget', 'in clearSubSubscribe', b, this.data);
                if (b) {
                    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
                    var ctx = canvasEl.getContext("2d");
                    this.slider.position = -1;
                    this.redraw(this.segmentPositions[2], ctx);
                }
            })
        }
        
    }

    ngOnDestroy() {
        if (this.clearSub) {
            this.clearSub.unsubscribe();
        }
    }

    ngAfterViewChecked() {
        this.reinitialize();
        if (this.segmentPositions != null) {
             var labels = [this.word1Label, '', this.word2Label, '', this.word3Label];
            
            for(var i = 0; i < this.segmentPositions.length; i++) {
                this.drawLabel(labels[i], this.segmentPositions[i]);
            }
        }
    }


    static isNotableChange(yesterdayValue : number, todayValue : number) : boolean {
      if (todayValue >= 75) {
          return true;
      } else if(todayValue >= 0 && yesterdayValue > -1){
          let nodeValueThreshold : number = 200 /  (SymptomWidget.NUM_NODES - 1); //2 nodes away
          return Math.abs(yesterdayValue - todayValue) >=  nodeValueThreshold;
      } 
      return false;
    }


    isNotableChange(): boolean{
        let yesterday = this.yesterdayValue && this.yesterdayValue.yesterdayValue > -1 ? this.yesterdayValue.yesterdayValue : -1;
        let today = (this.slider.position > -1) ? this.sliderValueToMeasurementValue() : -1;    
        return SymptomWidget.isNotableChange(yesterday, today);
    }
    
    reinitialize() {
 
        if (this.canvas && this.data && this.canvasParent && this.canvasWidth != this.canvasParent.nativeElement.offsetWidth) {
            
            this.canvasWidth = this.canvasParent.nativeElement.offsetWidth;//(window.innerWidth > 680) ? 600  : 370;//
            //console.log('setting canvasWidth', this.canvasWidth, window.innerWidth);
            if (this.data.currentVal == undefined || this.data.currentVal == null){ this.data.currentVal = -1; } // <=== Used to be this.data.formVal = -1 Would overwrite whatever value I passed everytime onChange was called
            this.width = this.canvasWidth;// - SymptomWidget.INSET; // 30 for inset, margins on the content
            this.lineMargin = SymptomWidget.MARGIN * this.width;
            var segmentWidth: number = ((this.width - this.lineMargin * 2) / (SymptomWidget.NUM_NODES - 1));
            const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
            this.captureMouseEvents(canvasEl);
            this.segmentPositions = [];
            for (let i=0; i < SymptomWidget.NUM_NODES; i++) {
                this.segmentPositions.push((this.lineMargin + (i * segmentWidth) + SymptomWidget.X_OFFSET));
            }
            //console.log('segment positions : segementpositions, linemargin, segmentwidth', this.segmentPositions, this.lineMargin, segmentWidth, this.width);
            var startPosition: number = this.segmentPositions[2];
            // this.canvas.nativeElement.width = this.width
            this.canvas.nativeElement.height = SymptomWidget.HEIGHT;
            var ctx = canvasEl.getContext("2d");
            this.canvas.nativeElement.width = this.canvasWidth;
            this.slider = new Slider(this);
            this.slider.x = startPosition;
            this.drawBackground(ctx);
            this.drawYesterdayValue(ctx); 
            this.drawCurrentValue();

            // this.slider.draw(startPosition, SymptomWidget.LINE_OFFSET, ctx);
        }
    }

    drawYesterdayValue(ctx) {
        if (this.yesterdayValue && this.yesterdayValue.yesterdayValue != undefined) {
            this.yesterdayPos = this.lineMargin + SymptomWidget.X_OFFSET + ((this.width - this.lineMargin * 2) * (100 - this.yesterdayValue.yesterdayValue ) / 100);
            this.drawDayBefore(ctx);
        } else {
            this.yesterdayPos = -1;
        }
    }

    logNoteForTrackable(){
        this.callActionSheet.emit(this.data);
    }

    drawCurrentValue() {
        if(this.data){
            if (this.data.currentVal != undefined && this.data.currentVal != null && this.data.currentVal > -1) {
            //if (this.data.formVal != null && this.data.formVal != undefined && this.data.formVal > -1){
                let formVal =  this.data.currentVal;
                let pos = Math.floor((100 - formVal) * (SymptomWidget.NUM_NODES - 1) / 100);
                this.slider.position = pos;
                let ctx = this.canvas.nativeElement.getContext("2d")
                this.slider.moveToNoAnimation(ctx, this.segmentPositions);
            }
        }
    }

    drawBackground(ctx) {
        ctx.fillStyle = "#7f7f7f";
        ctx.fillRect(this.lineMargin + 1, SymptomWidget.LINE_OFFSET, this.width - (2 * this.lineMargin) + SymptomWidget.X_OFFSET, 1);
        this.drawBackgroundCirclesAndLabels(ctx);
    }

    drawLabel(label, position) {
        var labelElement = label.nativeElement;
        if (labelElement) {
            var target = this.canvas.nativeElement.offsetLeft + position - labelElement.offsetWidth / 2;
            labelElement.style.left = target + 'px';
            labelElement.classList.add('visible');
        }
    }

    drawBackgroundCirclesAndLabels(ctx) {
        for(let n = 0; n < this.segmentPositions.length; n++) {
            ctx.beginPath();
            ctx.arc(this.segmentPositions[n], SymptomWidget.LINE_OFFSET, SymptomWidget.NODE_RADIUS, 0, 2 * Math.PI);
            ctx.fill();
        }
    }

    
    drawDayBefore(ctx) {
        let y = SymptomWidget.LINE_OFFSET + (3 *  SymptomWidget.NODE_RADIUS);
        ctx.fillStyle = '#B2B2B2';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(this.yesterdayPos - SymptomWidget.YESTERDAY_CARAT, y + SymptomWidget.YESTERDAY_CARAT);
        ctx.lineTo(this.yesterdayPos, y);
        ctx.lineTo(this.yesterdayPos + SymptomWidget.YESTERDAY_CARAT, y + SymptomWidget.YESTERDAY_CARAT);
        ctx.lineTo(this.yesterdayPos - SymptomWidget.YESTERDAY_CARAT, y + SymptomWidget.YESTERDAY_CARAT)
        ctx.fill();

    }

    ngAfterViewInit() {

    }

    onSelect(num) {
        //MobileLog.logClassLevel(0, 'SymptomWidget',num);
        this.data.currentVal = num;
        this.data.dirty = true;


        this.caller.saveLoggingItem(this.data, false, 'How I Feel');
        this.data.dirty = false;
    }


    isDisabled(index) {
        return (this.disabled == index)
    }

    setTrackable() {
            this.caller.setTrackable(this.data);
    }

    getYesterdayText() : string {
       //MobileLog.logClassLevel(0, 'SymptomWidget','getYesterdayText' , this.caller.dateStr, this.caller.yesterEpochDay);
         let todayEpochDay = DateUtil.toEpochDayFromDate(new Date());
         let theDayBefore = moment(this.caller.dateStr).subtract(1, 'days');
        return 'yesterday';
    }
}

export class Slider {

    x: number;
    y: number;
    position: number = -1;
    selected: boolean = false;
    caller: SymptomWidget;
    moveInterval = null;
    moving

    static RADIUS: number = 10;

    constructor(caller: SymptomWidget) {
        this.position = -1;
        this.caller = caller;
    }

    contains(x: number, y: number) {
        // MobileLog.logClassLevel(0, 'SymptomWidget', ('x: ' + x + ', y: ' + y + ' vs. ' + 'x: ' + this.x + ', y: ' + this.y );
        return ((x >= this.x - Slider.RADIUS) && (x <= this.x + Slider.RADIUS) &&
            (y >= this.y - Slider.RADIUS) && (y <= this.y + Slider.RADIUS))
    }

    draw(x: number, y: number, ctx) {
        // MobileLog.logClassLevel(0, 'SymptomWidget','Drawing at ' + this.position );
        if (this.position > -1) {
            ctx.fillStyle = SymptomWidget.POSITION_COLORS[this.position];
            ctx.beginPath();
            ctx.arc(x, y, Slider.RADIUS, 0, 2 * Math.PI);
            ctx.fill();
            
            ctx.strokeStyle = SymptomWidget.POSITION_BORDER_COLORS[this.position];
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.arc(x, y, Slider.RADIUS, 0, 2 * Math.PI);
            ctx.stroke();
            
            this.x = x;
            this.y = y;
        }
    }

    setSelected(selected: boolean) {
        //MobileLog.logClassLevel(0, 'SymptomWidget','setting slider.isSelected=' + selected);
        this.selected = selected;
    }

    isSelected(): boolean {
        return this.selected;
    }

    moveToNearest(ctx, segmentPositions: number[]) {
        this.position = this.getNearest(segmentPositions);
        this.moveTo(ctx, segmentPositions);
    }

    moveTo(ctx, segmentPositions: number[]) {
        if(this.position > -1) {
            var goal = segmentPositions[this.position];
            var slider = this;
            if(this.moveInterval) {
                clearInterval(this.moveInterval);
            }
            this.moveInterval = setInterval(function() {
                var diff = goal - slider.x;
                if(Math.abs(diff) < 1) {
                    slider.caller.redraw(goal, ctx);
                    clearInterval(slider.moveInterval);
                    slider.moveInterval = null;
                    slider.caller.setTrackable();
                    return;
                }
                var change = diff * .12;
                if(Math.abs(change) < 1)
                    change = diff >= 0 ? 1 : -1;
                slider.caller.redraw(slider.x + change, ctx);
            }, 5)
        }
    }

    moveToNoAnimation(ctx, segmentPositions: number[]) {
      if(this.position > -1) {
          var goal = segmentPositions[this.position];
          var slider = this;
          slider.caller.redraw(goal, ctx);
          
      }
  }


    private getNearest(segmentPositions: number[]): number {
        var ret = -1;
        var nearestDistance = 1000000;
        for(var n = 0; n < segmentPositions.length; n++) {
            var test = Math.abs(segmentPositions[n] - this.x);
            if(test < nearestDistance) {
                nearestDistance = test;
                ret = n;
            }
        }
        //MobileLog.logClassLevel(0, 'SymptomWidget','getNearest=' + ret + ' x=' + this.x + ' segs=' + JSON.stringify(segmentPositiofns));
        return ret;
    }


}
